import { sortDataFn } from './sortDataFn';
export const detailsChartFormattedData = (timeseries) => {
    var _a;
    if (!timeseries || timeseries.timeSeriesData.length <= 0) {
        return [{ name: '', data: [[0, 0]] }];
    }
    return (_a = timeseries.timeSeriesData) === null || _a === void 0 ? void 0 : _a.map((series) => {
        var _a;
        const seriesName = Object.keys(series)[0];
        const seriesData = (_a = series[seriesName]) === null || _a === void 0 ? void 0 : _a.map(({ date, value }) => [
            new Date(date).getTime(),
            value,
        ]);
        return {
            name: seriesName,
            data: seriesData.sort(sortDataFn),
        };
    });
};
//# sourceMappingURL=detailsChartFormattedData.js.map